import React from "react"

export const WizardStateRefinementItem = ({
  label,
  current_wizard_state_refinement,
  set_current_wizard_state_refinement,
  isRefined,
  all_states,
}) => {
  const refine_state = () => {
    const new_refinement_array = current_wizard_state_refinement.includes(label)
      ? current_wizard_state_refinement.filter((ref_item) => ref_item !== label)
      : [...current_wizard_state_refinement, label]

    set_current_wizard_state_refinement(
      !!new_refinement_array.length ? new_refinement_array : all_states
    )
  }
  const refine_single_state = () => {
    set_current_wizard_state_refinement([label])
  }

  return (
    <div className="is-flex m-2 wizard-checkbox-item">
      <div
        onClick={refine_state}
        aria-label="Refine Search"
        role="button"
        tabIndex="-1"
        onKeyDown={refine_state}
        className={`wizard-checkbox${isRefined ? " is-refined" : ""}`}
      ></div>
      <span
        onClick={refine_state}
        aria-label="Refine Search"
        role="button"
        tabIndex="-1"
        onKeyDown={refine_state}
        className="my-auto has-text-mitternachtsblau is-clickable has-text-left"
      >
        {label}
      </span>
      <button
        onClick={refine_single_state}
        className="button is-small is-mitternachtsblau is-outlined ml-auto has-text-weight-bold"
      >
        NUR
      </button>
    </div>
  )
}
